import axios from "axios";
const jsonConfig = require("../../Config.json");

const createUserByAdminRequest = async (userDataRequest) => {
  let allResponse = {}
  try {
    const getallresponse = await axios.post(
      jsonConfig.apiUrl + "CreateUserByAdmin",
      userDataRequest,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );

    allResponse = getallresponse;

    return Promise.resolve(allResponse)
  }
  catch (error) {
    console.log("errrrrr", error);
    return Promise.reject(error);
  }
}

export default createUserByAdminRequest;